import { render, staticRenderFns } from "./iconPhoneCase.vue?vue&type=template&id=ff0ac628&scoped=true"
import script from "./iconPhoneCase.vue?vue&type=script&lang=js"
export * from "./iconPhoneCase.vue?vue&type=script&lang=js"
import style0 from "./iconPhoneCase.vue?vue&type=style&index=0&id=ff0ac628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0ac628",
  null
  
)

export default component.exports